<template>
	<div id="shippersurvey-main">
		<div class="row">
			<div class="col-sm-12">
				<div class="row mb-1">
					<div class="col-sm-7">
						<div class="d-flex align-items-center mb-2">
							<h4 class="m-0 me-4">SHIPPER SURVEY</h4>
							<a id="add_shippersurvey_btn" class="btn btn-success btn-sm" href="#" role="button" data-bs-toggle="modal" data-bs-target="#addShipperSurveyModal" v-if="['110', '111'].indexOf(all_permissions) >= 0">ADD</a>
						</div>
					</div>
				</div>
				<DataTableComponent :dataprops="dataprops" @view-object="viewShipperSurvey" @upload-object="uploadImages" @duplicate-object="duplicateObject" @print-object="printShippersurvey" @edit-object="prepareEditShipperSurvey" @toggle-object-status="toggleShipperSurvey" v-if="mode != 'mobileapp'"></DataTableComponent>
			</div>
		</div>
		<div class="modal fade" ref="addEditModal" id="addShipperSurveyModal" tabindex="-1" aria-labelledby="addShipperSurveyModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="addShipperSurveyModalLabel"><span v-if="shippersurveyForAdd.id > 0">Edit</span><span v-else>Add</span> Shipper Survey Record</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cancelAddEdit"></button>
					</div>
					<div class="modal-body">
						<div class="row mb-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label for="add_shippersurvey_tank_container_no" class="form-label text-uppercase fw-bold mb-0 mt-1 me-3">Tank No <span class="mandatory">*</span></label
								><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<div class="input-group">
									<MaskInput v-model="shippersurveyForAdd.tank_container_no" mask="AAAA-######-#" class="form-control" :readonly="tankNoVerified" placeholder="Enter Tank No" textmode="uppercase"/>
									<span class="input-group-text" :class="tankNoVerified ? 'bg-success' : 'bg-danger'">
										<i class="ph ph-check text-white" v-if="tankNoVerified"></i>
										<i class="ph ph-x text-white" v-if="!tankNoVerified"></i>
									</span>
								</div>
								<template v-for="error of v$.shippersurveyForAdd.tank_container_no.$errors" :key="error.$uid">
									<div class="mandatory mb-1">{{ error.$message }}</div>
								</template>
							</div>
							<template v-if="tankNoVerified">
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_ref_no" class="form-label text-uppercase fw-bold mb-0 mt-1">Ref No</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<input type="text" class="form-control" v-model="shippersurveyForAdd.ref_no" id="add_shippersurvey_ref_no" placeholder="AUTOGENERATED" readonly />
									</div>
								</div>
							</template>
						</div>
						<div class="row mb-0 mb-sm-4" v-if="shippersurveyForAdd.id == 0 && tankNoVerified">
							<div class="col-9 pt-1 offset-sm-3">
								<label for="">Tank last used: <span v-if="lastThree && lastThree.length > 0">On {{  lastThree.join(", ") }}</span><span v-else>Never</span></label>
							</div>
						</div>
						<template v-if="tankNoVerified">
							<div class="row mb-0 mb-sm-4">
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_survey_date" class="form-label text-uppercase fw-bold mb-0 mt-1">Survey Date</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<MaskInput v-model="shippersurveyForAdd.survey_date" mask="##-##-####" class="form-control" textmode="uppercase" placeholder="DD-MM-YYYY"/>
										<!-- <input type="date" class="form-control" v-model="shippersurveyForAdd.survey_date" id="add_shippersurvey_survey_date" placeholder="Enter Survey Date" /> -->
									</div>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_company_id" class="form-label text-uppercase fw-bold mb-0 mt-1">Company Name <span class="mandatory">*</span></label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<select class="form-select" v-model="shippersurveyForAdd.company_id" id="add_company_id">
											<optgroup v-if="allCompanyIdList" label="Choose">
												<template v-for="companyId in allCompanyIdList" :key="companyId.id">
													<option :value="companyId.id">{{ companyId.name }}</option>
												</template>
											</optgroup>
										</select>
									</div>
									<template v-for="error of v$.shippersurveyForAdd.company_id.$errors" :key="error.$uid">
										<div class="mandatory mb-1">{{ error.$message }}</div>
									</template>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_last_cargo_carried" class="form-label text-uppercase fw-bold mb-0 mt-1 me-3">Last Cargo Carried</label>
									<a href="#" class="cstooltip d-none d-md-inline-block" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<input type="text" class="form-control" v-model="shippersurveyForAdd.last_cargo_carried" id="add_shippersurvey_last_cargo_carried" placeholder="Enter Last Cargo Carried" />
									</div>
								</div>
								<!-- <div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_cha" class="form-label text-uppercase fw-bold mb-0 mt-1 me-3">CHA</label>
									<a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<input type="text" class="form-control" v-model="shippersurveyForAdd.cha" id="add_shippersurvey_cha" placeholder="Enter CHA" />
									</div>
								</div> -->
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_for_shipper_id" class="form-label text-uppercase fw-bold mb-0 mt-1">For Shipper</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<multiselect v-model="shippersurveyForAdd.for_shipper_id" :options="allForShipperIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
									</div>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_surveyor_id" class="form-label text-uppercase fw-bold mb-0 mt-1">Surveyor</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<multiselect v-model="shippersurveyForAdd.surveyor_id" :options="allSurveyorIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_csc_no" class="form-label text-uppercase fw-bold mb-0 mt-1 me-3">Csc No</label>
									<a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<input type="text" class="form-control" v-model="shippersurveyForAdd.csc_no" id="add_shippersurvey_csc_no" placeholder="Enter Csc No" />
									</div>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_customer_id" class="form-label text-uppercase fw-bold mb-0 mt-1">Customer/CHA</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<multiselect v-model="shippersurveyForAdd.customer_id" :options="allCustomerIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_inspection_location_id" class="form-label text-uppercase fw-bold mb-0 mt-1">Place of Inspection</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<multiselect v-model="shippersurveyForAdd.inspection_location_id" :options="allInspectionLocationIdList" :custom-label="displayLabelSetting" placeholder="Select one" selectLabel="" deselectLabel=""></multiselect>
									</div>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_type" class="form-label text-uppercase fw-bold mb-0 mt-1">Type</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<input type="text" class="form-control" v-model="shippersurveyForAdd.type" id="add_shippersurvey_type" placeholder="Enter Type" />
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_last_inspection_date" class="form-label text-uppercase fw-bold mb-0 mt-1">Last Inspection Date</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<input type="text" class="form-control" v-model="shippersurveyForAdd.last_inspection_date" id="add_shippersurvey_last_inspection_date" placeholder="Enter Last Inspection Date" />
									</div>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_mfg_date" class="form-label text-uppercase fw-bold mb-0 mt-1">Mfg Date</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<input type="text" class="form-control" v-model="shippersurveyForAdd.mfg_date" id="add_shippersurvey_mfg_date" placeholder="Enter Next Date" />
										<!-- <MonthYearPicker v-model="shippersurveyForAdd.mfg_date" :min="new Date(1990, 1, 1)" :max="new Date()" returnmode="String" class="form-select" /></div> -->
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_next_date" class="form-label text-uppercase fw-bold mb-0 mt-1">Next Date</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<input type="text" class="form-control" v-model="shippersurveyForAdd.next_date" id="add_shippersurvey_next_date" placeholder="Enter Next Date" />
									</div>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_capacity" class="form-label text-uppercase fw-bold mb-0 mt-1 me-3">Capacity</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<input type="number" class="form-control" v-empty-zero v-model="shippersurveyForAdd.capacity" id="add_shippersurvey_capacity" placeholder="Enter Capacity" />
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_gross_wt" class="form-label text-uppercase fw-bold mb-0 mt-1 me-3">Gross Wt</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<input type="number" class="form-control" v-empty-zero v-model="shippersurveyForAdd.gross_wt" id="add_shippersurvey_gross_wt" placeholder="Enter Gross Wt" />
									</div>
								</div>
								<!-- <div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_ref" class="form-label text-uppercase fw-bold mb-0 mt-1">Ref</label
									><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<input type="text" class="form-control" v-model="shippersurveyForAdd.ref" id="add_shippersurvey_ref" placeholder="Enter Ref" />
									</div>
								</div> -->
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<label for="add_shippersurvey_tare_wt" class="form-label text-uppercase fw-bold mb-0 mt-1 me-3">Tare Wt</label>
								</div>
								<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
									<div>
										<input type="number" class="form-control" v-empty-zero v-model="shippersurveyForAdd.tare_wt" id="add_shippersurvey_tare_wt" placeholder="Enter Tare Wt" />
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-7 text-end">
									<label for="add_shippersurvey_frame_tank" class="form-label text-uppercase fw-bold mb-0 mt-1">Frame,Tank and walkways free of contamination and cargo</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0 text-end">
									<div>
										<select class="form-select" v-model="shippersurveyForAdd.frame_tank" id="add_frame_tank">
											<optgroup v-if="arrYesNoNA" label="Choose">
												<template v-for="frameTank in arrYesNoNA" :key="frameTank.id">
													<option :value="frameTank.id">{{ frameTank.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-7 text-end">
									<label for="add_shippersurvey_manlid_valve" class="form-label text-uppercase fw-bold mb-0 mt-1">Manlid and valve compartments free of contamination and cargo</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0 text-end">
									<div>
										<select class="form-select" v-model="shippersurveyForAdd.manlid_valve" id="add_manlid_valve">
											<optgroup v-if="arrYesNoNA" label="Choose">
												<template v-for="manlidValve in arrYesNoNA" :key="manlidValve.id">
													<option :value="manlidValve.id">{{ manlidValve.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-7 text-end">
									<label for="add_shippersurvey_serial_nos" class="form-label text-uppercase fw-bold mb-0 mt-1">Serial numbers and statutory markings legible</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0 text-end">
									<div>
										<select class="form-select" v-model="shippersurveyForAdd.serial_nos" id="add_serial_nos">
											<optgroup v-if="arrYesNoNA" label="Choose">
												<template v-for="serialNos in arrYesNoNA" :key="serialNos.id">
													<option :value="serialNos.id">{{ serialNos.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-7 text-end">
									<label for="add_shippersurvey_steam_jacket" class="form-label text-uppercase fw-bold mb-0 mt-1">Unit having steam jacket</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0 text-end">
									<div>
										<select class="form-select" v-model="shippersurveyForAdd.steam_jacket" id="add_steam_jacket">
											<optgroup v-if="arrYesNoNA" label="Choose">
												<template v-for="steamJacket in arrYesNoNA" :key="steamJacket.id">
													<option :value="steamJacket.id">{{ steamJacket.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-7 text-end">
									<label for="add_shippersurvey_bullet_seal" class="form-label text-uppercase fw-bold mb-0 mt-1">Unit having bottom seal provision for bullet seal</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0 text-end">
									<div>
										<select class="form-select" v-model="shippersurveyForAdd.bullet_seal" id="add_bullet_seal">
											<optgroup v-if="arrYesNoNA" label="Choose">
												<template v-for="bulletSeal in arrYesNoNA" :key="bulletSeal.id">
													<option :value="bulletSeal.id">{{ bulletSeal.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-2 mb-sm-4">
								<div class="col-md-9 d-flex flex-row flex-wrap flex-md-nowrap align-items-center gap-2 text-end">
									<label for="add_shippersurvey_manlid_cover" class="form-label text-uppercase fw-bold mb-0 mt-1 flex-shrink-0 flex-grow-1">Unit having</label>
									<select class="form-select w-auto" v-model="shippersurveyForAdd.gasket_type" id="add_gasket_type">
										<optgroup v-if="allGasketTypeList" label="Choose">
											<template v-for="gasketType in allGasketTypeList" :key="gasketType.id">
												<option :value="gasketType.id">{{ gasketType.title }}</option>
											</template>
										</optgroup>
									</select>
									<label for="add_shippersurvey_manlid_cover" class="form-label text-uppercase fw-bold mb-0 mt-1 flex-shrink-0">gasket on manlid cover</label>
									<div>
										<select class="form-select" v-model="shippersurveyForAdd.manlid_cover" id="add_manlid_cover">
											<optgroup v-if="arrYesNoNA" label="Choose">
												<template v-for="manlidCover in arrYesNoNA" :key="manlidCover.id">
													<option :value="manlidCover.id">{{ manlidCover.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
								<!-- <div class="col-4 col-sm-2 mb-2 mb-sm-0 text-end">
								</div> -->
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-7 text-end">
									<label for="add_shippersurvey_distick" class="form-label text-uppercase fw-bold mb-0 mt-1">Distick orginally fitted</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0 text-end">
									<div>
										<select class="form-select" v-model="shippersurveyForAdd.distick" id="add_distick">
											<optgroup v-if="arrYesNoNA" label="Choose">
												<template v-for="distick in arrYesNoNA" :key="distick.id">
													<option :value="distick.id">{{ distick.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-7 text-end">
									<label for="add_shippersurvey_calibration" class="form-label text-uppercase fw-bold mb-0 mt-1">Calibration chart fitted</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0 text-end">
									<div>
										<select class="form-select" v-model="shippersurveyForAdd.calibration" id="add_calibration">
											<optgroup v-if="arrYesNoNA" label="Choose">
												<template v-for="calibration in arrYesNoNA" :key="calibration.id">
													<option :value="calibration.id">{{ calibration.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-7 text-end">
									<label for="add_shippersurvey_siphon_tube" class="form-label text-uppercase fw-bold mb-0 mt-1">Siphon tube orginally fitted</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0 text-end">
									<div>
										<select class="form-select" v-model="shippersurveyForAdd.siphon_tube" id="add_siphon_tube">
											<optgroup v-if="arrYesNoNA" label="Choose">
												<template v-for="siphonTube in arrYesNoNA" :key="siphonTube.id">
													<option :value="siphonTube.id">{{ siphonTube.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-7 text-end">
									<label for="add_shippersurvey_pressure_gauge" class="form-label text-uppercase fw-bold mb-0 mt-1">Pressure gauge fitted</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0 text-end">
									<div>
										<select class="form-select" v-model="shippersurveyForAdd.pressure_gauge" id="add_pressure_gauge">
											<optgroup v-if="arrYesNoNA" label="Choose">
												<template v-for="pressureGauge in arrYesNoNA" :key="pressureGauge.id">
													<option :value="pressureGauge.id">{{ pressureGauge.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-7 text-end">
									<label for="add_shippersurvey_temperature_gauge" class="form-label text-uppercase fw-bold mb-0 mt-1">Temperature gauge fitted</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0 text-end">
									<div>
										<select class="form-select" v-model="shippersurveyForAdd.temperature_gauge" id="add_temperature_gauge">
											<optgroup v-if="arrYesNoNA" label="Choose">
												<template v-for="temperatureGauge in arrYesNoNA" :key="temperatureGauge.id">
													<option :value="temperatureGauge.id">{{ temperatureGauge.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-7 text-end">
									<label for="add_shippersurvey_prv_poppet" class="form-label text-uppercase fw-bold mb-0 mt-1">PRV with poppet</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0 text-end">
									<div>
										<select class="form-select" v-model="shippersurveyForAdd.prv_poppet" id="add_prv_poppet">
											<optgroup v-if="arrYesNoNA" label="Choose">
												<template v-for="prvPoppet in arrYesNoNA" :key="prvPoppet.id">
													<option :value="prvPoppet.id">{{ prvPoppet.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-7 text-end">
									<label for="add_shippersurvey_top_provision" class="form-label text-uppercase fw-bold mb-0 mt-1">Top loading provision</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0 text-end">
									<div>
										<select class="form-select" v-model="shippersurveyForAdd.top_provision" id="add_top_provision">
											<optgroup v-if="arrYesNoNA" label="Choose">
												<template v-for="topProvision in arrYesNoNA" :key="topProvision.id">
													<option :value="topProvision.id">{{ topProvision.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-7 text-end">
									<label for="add_shippersurvey_interior_clean" class="form-label text-uppercase fw-bold mb-0 mt-1">Interior clean dry and odourless</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0 text-end">
									<div>
										<select class="form-select" v-model="shippersurveyForAdd.interior_clean" id="add_interior_clean">
											<optgroup v-if="arrYesNoNA" label="Choose">
												<template v-for="interiorClean in arrYesNoNA" :key="interiorClean.id">
													<option :value="interiorClean.id">{{ interiorClean.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-7 text-end">
									<label for="add_shippersurvey_valves_free" class="form-label text-uppercase fw-bold mb-0 mt-1">VALVES/FITTINGS free from previous cargo</label>
								</div>
								<div class="col-4 col-sm-2 mb-2 mb-sm-0 text-end">
									<div>
										<select class="form-select" v-model="shippersurveyForAdd.valves_free" id="add_valves_free">
											<optgroup v-if="arrYesNoNA" label="Choose">
												<template v-for="valvesFree in arrYesNoNA" :key="valvesFree.id">
													<option :value="valvesFree.id">{{ valvesFree.title }}</option>
												</template>
											</optgroup>
										</select>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-7 text-end">
									<label for="add_shippersurvey_non_transferable" class="form-label text-uppercase fw-bold mb-0 mt-1 me-3">Non transferable cargo stains interior shell</label>
									<a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
								</div>
								<div class="col-5 text-end">
									<div>
										<input type="text" class="form-control" v-model="shippersurveyForAdd.non_transferable" id="add_shippersurvey_non_transferable" placeholder="Enter value" />
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-7 text-end">
									<label for="add_shippersurvey_polish_buffing" class="form-label text-uppercase fw-bold mb-0 mt-1 me-3">Polish/Buffing marks in interior</label
									><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
								</div>
								<div class="col-5 text-end">
									<div>
										<input type="text" class="form-control" v-model="shippersurveyForAdd.polish_buffing" id="add_shippersurvey_polish_buffing" placeholder="Enter Polish Buffing" />
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-12 text-center">
									1.0Kg/cm2air pressure/leak test carried out with Teflon/Rubber gasket.
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-12 col-sm-7 mb-2 mb-sm-0 text-sm-end">
									<label for="add_shippersurvey_note" class="form-label text-uppercase fw-bold mb-0 mt-1 me-3">Remarks</label>
									<a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
								</div>
								<div class="col-12 col-sm-5 mb-2 mb-sm-0 text-end">
									<div>
										<textarea class="form-control" v-model="shippersurveyForAdd.note" id="add_shippersurvey_note" placeholder="Enter Note"></textarea>
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-12 col-sm-7 mb-2 mb-sm-0 text-sm-end">
									<label for="add_shippersurvey_manlid_seal_no" class="form-label text-uppercase fw-bold mb-0 mt-1 me-3">Manlid Seal No</label>
								</div>
								<div class="col-12 col-sm-5 mb-2 mb-sm-0 text-end">
									<div>
										<input type="text" class="form-control" v-model="shippersurveyForAdd.manlid_seal_no" id="add_shippersurvey_manlid_seal_no" placeholder="Enter Manlid Seal No" />
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-12 col-sm-7 mb-2 mb-sm-0 text-sm-end">
									<label for="add_shippersurvey_airline_seal_no" class="form-label text-uppercase fw-bold mb-0 mt-1 me-3">Airline Seal No</label
									><a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
								</div>
								<div class="col-12 col-sm-5 mb-2 mb-sm-0 text-end">
									<div>
										<input type="text" class="form-control" v-model="shippersurveyForAdd.airline_seal_no" id="add_shippersurvey_airline_seal_no" placeholder="Enter Airline Seal No" />
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-12 col-sm-7 mb-2 mb-sm-0 text-sm-end">
									<label for="add_shippersurvey_bottom_seal_no" class="form-label text-uppercase fw-bold mb-0 mt-1 me-3">Bottom Seal No</label>
									<a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
								</div>
								<div class="col-12 col-sm-5 mb-2 mb-sm-0 text-end">
									<div>
										<input type="text" class="form-control" v-model="shippersurveyForAdd.bottom_seal_no" id="add_shippersurvey_bottom_seal_no" placeholder="Enter Bottom Seal No" />
									</div>
								</div>
							</div>
							<div class="row mb-0 mb-sm-4">
								<div class="col-12 col-sm-7 mb-2 mb-sm-0 text-sm-end">
									<label for="add_shippersurvey_top_seal" class="form-label text-uppercase fw-bold mb-0 mt-1 me-3">Top Discharge Seal</label>
									<a href="#" class="cstooltip" data-tooltip="Allowed characters are A-Z, 0-9 and space, comma, full stop, underscore, dash and single quote." tabindex="-1"><i class="ph ph-question"></i></a>
								</div>
								<div class="col-12 col-sm-5 mb-2 mb-sm-0 text-end">
									<div>
										<input type="text" class="form-control" v-model="shippersurveyForAdd.top_seal" id="add_shippersurvey_top_seal" placeholder="Enter Top Seal" />
									</div>
								</div>
							</div>
						</template>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-outline-dark btn-sm" data-bs-dismiss="modal" @click="cancelAddEdit()">CLOSE</button>
						<button type="button" class="btn btn-dark btn-sm" @click="verifyTankNumber()" v-if="!tankNoVerified">VERIFY TANK NUMBER</button>
						<button type="button" class="btn btn-dark btn-sm" v-else @click="saveShipperSurvey()">SAVE CHANGES</button>
					</div>
				</div>
			</div>
		</div>

		<div class="modal fade" ref="readModal" id="readShipperSurveyModal" tabindex="-1" aria-labelledby="readShipperSurveyModalLabel" aria-hidden="true" v-if="readShipperSurvey">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="readShipperSurveyModalLabel">View Shipper Survey Record</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cancelAddEdit"></button>
					</div>
					<div class="modal-body">
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Tank Container No</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.tank_container_no">{{ readShipperSurvey.tank_container_no }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Ref No</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.ref_no">{{ readShipperSurvey.ref_no }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Survey Date</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.survey_date">{{ formatMySQLDate(readShipperSurvey.survey_date, "MMM dd, yyyy") }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Company</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.company?.name">{{ readShipperSurvey.company?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Last Cargo Carried</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.last_cargo_carried">{{ readShipperSurvey.last_cargo_carried }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">CHA</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.cha">{{ readShipperSurvey.cha }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">For Shipper</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.for_shipper?.name">{{ readShipperSurvey.for_shipper?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Surveyor</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.surveyor?.name">{{ readShipperSurvey.surveyor?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">CSC No</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.csc_no">{{ readShipperSurvey.csc_no }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Customer</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.customer?.name">{{ readShipperSurvey.customer?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Inspection Location</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.inspection_location?.name">{{ readShipperSurvey.inspection_location?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Type</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.type">{{ readShipperSurvey.type }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Last Inspection Date</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.last_inspection_date">{{ readShipperSurvey.last_inspection_date }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Mfg Date</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.mfg_date">{{ readShipperSurvey.mfg_date }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Next Date</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.next_date">{{ readShipperSurvey.next_date }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Capacity</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.capacity">{{ readShipperSurvey.capacity }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Gross Wt</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.gross_wt">{{ readShipperSurvey.gross_wt }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
							<!-- <div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Ref</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.ref">{{ readShipperSurvey.ref }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div> -->
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Tare Wt</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.tare_wt">{{ readShipperSurvey.tare_wt }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-0 mb-sm-4">
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Status</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span class="badge rounded-pill bg-success" v-if="readShipperSurvey.status == 1">ACTIVE</span>
									<span class="badge rounded-pill bg-danger" v-if="readShipperSurvey.status == 0">INACTIVE</span>
								</div>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Created By</label>
							</div>
							<div class="col-6 col-sm-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.creator?.name">{{ readShipperSurvey.creator?.name }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Frame,Tank and walkways free of contamination and cargo</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.frame_tank == '1'">Yes</span>
									<span v-if="readShipperSurvey.frame_tank == '0'">No</span>
									<span v-if="readShipperSurvey.frame_tank == '-1'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Manlid and valve compartments free of contamination and cargo</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.manlid_valve == '1'">Yes</span>
									<span v-if="readShipperSurvey.manlid_valve == '0'">No</span>
									<span v-if="readShipperSurvey.manlid_valve == '-1'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Serial numbers and statutory markings legible</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.serial_nos == '1'">Yes</span>
									<span v-if="readShipperSurvey.serial_nos == '0'">No</span>
									<span v-if="readShipperSurvey.serial_nos == '-1'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Unit having steam jacket</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.steam_jacket == '1'">Yes</span>
									<span v-if="readShipperSurvey.steam_jacket == '0'">No</span>
									<span v-if="readShipperSurvey.steam_jacket == '-1'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Unit having bottom seal provision for bullet seal</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.bullet_seal == '1'">Yes</span>
									<span v-if="readShipperSurvey.bullet_seal == '0'">No</span>
									<span v-if="readShipperSurvey.bullet_seal == '-1'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">
									<span>Unit having&nbsp;</span>
									<span class="text-primary" v-if="readShipperSurvey.gasket_type == '1'">Super Tyt</span>
									<span class="text-primary" v-if="readShipperSurvey.gasket_type == '2'">Taflon</span>
									<span class="text-primary" v-if="readShipperSurvey.gasket_type == '3'">Rubber</span>
									<span class="text-primary" v-if="readShipperSurvey.gasket_type == '4'">Nylon</span>
									<span>&nbsp;gasket on manlid cover</span>
								</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.manlid_cover == '1'">Yes</span>
									<span v-if="readShipperSurvey.manlid_cover == '0'">No</span>
									<span v-if="readShipperSurvey.manlid_cover == '-1'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Distick orginally fitted</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.distick == '1'">Yes</span>
									<span v-if="readShipperSurvey.distick == '0'">No</span>
									<span v-if="readShipperSurvey.distick == '-1'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Calibration chart fitted</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.calibration == '1'">Yes</span>
									<span v-if="readShipperSurvey.calibration == '0'">No</span>
									<span v-if="readShipperSurvey.calibration == '-1'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Siphon Tube orginally fitted</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.siphon_tube == '1'">Yes</span>
									<span v-if="readShipperSurvey.siphon_tube == '0'">No</span>
									<span v-if="readShipperSurvey.siphon_tube == '-1'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Pressure Gauge fitted</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.pressure_gauge == '1'">Yes</span>
									<span v-if="readShipperSurvey.pressure_gauge == '0'">No</span>
									<span v-if="readShipperSurvey.pressure_gauge == '-1'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Temperature Gauge fitted</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.temperature_gauge == '1'">Yes</span>
									<span v-if="readShipperSurvey.temperature_gauge == '0'">No</span>
									<span v-if="readShipperSurvey.temperature_gauge == '-1'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">PRV with poppet</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.prv_poppet == '1'">Yes</span>
									<span v-if="readShipperSurvey.prv_poppet == '0'">No</span>
									<span v-if="readShipperSurvey.prv_poppet == '-1'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Top discharge Provision</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.top_provision == '1'">Yes</span>
									<span v-if="readShipperSurvey.top_provision == '0'">No</span>
									<span v-if="readShipperSurvey.top_provision == '-1'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Interior Clean dry and odourless</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.interior_clean == '1'">Yes</span>
									<span v-if="readShipperSurvey.interior_clean == '0'">No</span>
									<span v-if="readShipperSurvey.interior_clean == '-1'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">VALVES/FITTINGS free from previous cargo</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.valves_free == '1'">Yes</span>
									<span v-if="readShipperSurvey.valves_free == '0'">No</span>
									<span v-if="readShipperSurvey.valves_free == '-1'">NA</span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Non transferable cargo stains interior shell</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.non_transferable">{{ readShipperSurvey.non_transferable }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Polish/Buffing marks in interior</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.polish_buffing">{{ readShipperSurvey.polish_buffing }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-sm-4">
							<div class="col-12 text-center">
								1.0Kg/cm2air pressure/leak test carried out with Teflon/Rubber gasket.
							</div>
						</div>
						<div class="row mb-sm-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Remarks</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.note">{{ readShipperSurvey.note }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-sm-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Manlid Seal No</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.manlid_seal_no">{{ readShipperSurvey.manlid_seal_no }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-sm-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Airline Seal</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.airline_seal_no">{{ readShipperSurvey.airline_seal_no }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-sm-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Bottom Seal No</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.bottom_seal_no">{{ readShipperSurvey.bottom_seal_no }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
						<div class="row mb-sm-4">
							<div class="col-9 text-end">
								<label class="form-label text-uppercase fw-bold m-0">Top Discharge Seal</label>
							</div>
							<div class="col-3 mb-2 mb-sm-0">
								<div>
									<span v-if="readShipperSurvey.top_seal">{{ readShipperSurvey.top_seal }}</span
									><span v-else><i>Not specified</i></span>
								</div>
							</div>
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-outline-dark btn-sm" data-bs-dismiss="modal">CLOSE</button>
					</div>
				</div>
			</div>
		</div>
		
		<!-- Upload Images -->
		<UploadImages :dataprops="uploadDataprops" @refresh-object="refreshObject"></UploadImages>
		<!-- Upload Images -->
	</div>
</template>
<script>
	import {useVuelidate} from "@vuelidate/core";
	import {required, minValue, alphaNum, numeric, email, requiredIf, minLength} from "@vuelidate/validators";
	import * as bootstrap from "bootstrap";
	function initialState() {
		return {
			id: 0,
			ref_no: "",
			survey_date: "",
			company_id: null,
			last_cargo_carried: null,
			cha: null,
			tank_container_no: "",
			surveyor_id: null,
			for_shipper_id: null,
			customer_id: null,
			csc_no: "",
			type: "",
			inspection_location_id: null,
			mfg_date: "",
			last_inspection_date: "",
			capacity: 0,
			next_date: "",
			// ref: "",
			gross_wt: 0,
			tare_wt: 0,
			frame_tank: 1,
			manlid_valve: 1,
			serial_nos: 1,
			steam_jacket: 1,
			bullet_seal: 1,
			gasket_type: 1,
			manlid_cover: 1,
			distick: 1,
			calibration: 1,
			siphon_tube: 1,
			pressure_gauge: 1,
			temperature_gauge: 1,
			prv_poppet: 1,
			top_provision: 1,
			interior_clean: 1,
			valves_free: 1,
			non_transferable: "",
			polish_buffing: "",
			note: "",
			manlid_seal_no: "",
			airline_seal_no: "",
			bottom_seal_no: "",
			top_seal: "",
			action: ""
		};
	}
	function initialStateValidations() {
		return {
			ref_no: {minLengthValue: minLength(1)},
			survey_date: {},
			company_id: {required},
			tank_container_no: {required, minLengthValue: minLength(1)},
			surveyor_id: {},
			for_shipper_id: {},
			customer_id: {},
			csc_no: {minLengthValue: minLength(1)},
			type: {minLengthValue: minLength(1)},
			capacity: {minLengthValue: minLength(1)},
			// ref: {minLengthValue: minLength(1)},
			non_transferable: {minLengthValue: minLength(1)},
			polish_buffing: {minLengthValue: minLength(1)},
			note: {minLengthValue: minLength(1)},
			manlid_seal_no: {minLengthValue: minLength(1)},
			airline_seal_no: {minLengthValue: minLength(1)},
			bottom_seal_no: {minLengthValue: minLength(1)},
			top_seal: {minLengthValue: minLength(1)}
		};
	}
	export default {
		name: "ShipperSurveymaster",
		props: ["current_user_id", "all_permissions", "mode","param1","id"],
		setup() {
			return {
				v$: useVuelidate()
			};
		},
		data() {
			return {
				dataprops: {
					id: "shippersurvey-list",
					class: "a",
					base_url: this.docRoot+"/api/shippersurvey/",
					columns: [
						{title: "Ref No", property: "ref_no"},
						{title: "Company", property: "company.name", alt_value: "Not Specified"},
						{title: "Tank Container No", property: "tank_container_no"},
						{title: "Customer", property: "customer.name", alt_value: "Not Specified"},
						{title: "Csc No", property: "csc_no"},
						{title: "Inspection Date", property: "survey_date"},
						{title: "Created By", property: "creator.name", alt_value: "Not Specified"}
					],
					data_to_send: {current_user_id: this.current_user_id},
					reload: false,
					search: "simple"
				},
				uploadDataprops: {
					relatedObject: null,
					name: "ShipperSurvey",
				},
				tankNoVerified: false,
				lastThree: [],
				addEditModal: null,
				readModal: null,
				currentUser: siteUserObject,
				shippersurveyForAdd: initialState(),
				readShipperSurvey: {},
				allCompanyIdList: [],
				allSurveyorIdList: [],
				allForShipperIdList: [],
				allCustomerIdList: [],
				allInspectionLocationIdList: [],
				allGasketTypeList: [],
				arrYesNoNA: []
			};
		},
		validations() {
			return {
				shippersurveyForAdd: initialStateValidations()
			};
		},
		methods: {
			cancelAddEdit(event) {
				this.shippersurveyForAdd = initialState();
				this.tankNoVerified = false;
				this.v$.$reset();
			},
			duplicateObject(sSurvey) {
				let that = this;
				this.showConfirm("Are you sure you want to create a duplicate of this record?", "Yes", "No").then((result) => {
					if (result.isConfirmed) {
						if (sSurvey.surveyor_id) {
							if (Array.isArray(this.allSurveyorIdList) && this.allSurveyorIdList.length > 0) {
								let _allRelationList = this.allSurveyorIdList;
								let relationId = parseInt(sSurvey.surveyor_id);
								sSurvey.surveyor_id = _allRelationList.find(item => item.id === relationId);
							}
						}
						if (sSurvey.customer_id) {
							if (Array.isArray(this.allCustomerIdList) && this.allCustomerIdList.length > 0) {
								let _allRelationList = this.allCustomerIdList;
								let relationId = parseInt(sSurvey.customer_id);
								sSurvey.customer_id = _allRelationList.find(item => item.id === relationId);
							}
						}
						if (sSurvey.for_shipper_id) {
							if (Array.isArray(this.allCustomerIdList) && this.allCustomerIdList.length > 0) {
								let _allRelationList = this.allCustomerIdList;
								let relationId = parseInt(sSurvey.for_shipper_id);
								sSurvey.for_shipper_id = _allRelationList.find(item => item.id === relationId);
							}
						}
						if (sSurvey.inspection_location_id) {
							if (Array.isArray(this.allInspectionLocationIdList) && this.allInspectionLocationIdList.length > 0) {
								let _allRelationList = this.allInspectionLocationIdList;
								let relationId = parseInt(sSurvey.inspection_location_id);
								sSurvey.inspection_location_id = _allRelationList.find(item => item.id === relationId);
							}
						}
						this.shippersurveyForAdd = Object.assign({}, sSurvey);
						this.shippersurveyForAdd.id = 0;
						this.shippersurveyForAdd.ref_no = null;
						console.log(this.shippersurveyForAdd);
						this.tankNoVerified = false;
						this.addEditModal.show();
					}
				});
			},
			async saveShipperSurvey(event) {
				var thisVar = this;
				const result = await this.v$.$validate();
				if (!result) {
					this.showToast("Form validation failed. Please check.", "error", "bottom", 2000);
					console.log(this.v$.$errors);
					return;
				}
				// Validate the inspection date
				if ( this.shippersurveyForAdd.survey_date.length < 10) {
					this.showToast("Survey date is required", "error", "bottom", 2000);
					return;
				}
				else {
					// validate date using regex
					var dateRegex = /^(0[1-9]|1[0-9]|2[0-9]|3[0-1])-(0[1-9]|1[0-2])-\d{4}$/;
					if (!dateRegex.test(this.shippersurveyForAdd.survey_date)) {
						this.showToast("Invalid survey date format", "error", "bottom", 2000);
						return;
					}
				}

				if ( this.shippersurveyForAdd.surveyor_id != 'null' && typeof this.shippersurveyForAdd.surveyor_id === 'object' && this.shippersurveyForAdd.surveyor_id.id) {
					this.shippersurveyForAdd.surveyor_id = this.shippersurveyForAdd.surveyor_id.id;
				}
				if ( this.shippersurveyForAdd.customer_id != 'null' && typeof this.shippersurveyForAdd.customer_id === 'object' && this.shippersurveyForAdd.customer_id.id) {
					this.shippersurveyForAdd.customer_id = this.shippersurveyForAdd.customer_id.id;
				}
				if ( this.shippersurveyForAdd.for_shipper_id != 'null' && typeof this.shippersurveyForAdd.for_shipper_id === 'object' && this.shippersurveyForAdd.for_shipper_id.id) {
					this.shippersurveyForAdd.for_shipper_id = this.shippersurveyForAdd.for_shipper_id.id;
				}
				if ( this.shippersurveyForAdd.inspection_location_id != 'null' && typeof this.shippersurveyForAdd.inspection_location_id === 'object' && this.shippersurveyForAdd.inspection_location_id.id) {
					this.shippersurveyForAdd.inspection_location_id = this.shippersurveyForAdd.inspection_location_id.id;
				}

				if (!this.shippersurveyForAdd.action || this.shippersurveyForAdd.action == "") this.shippersurveyForAdd.action = "details";
				this.shippersurveyForAdd.created_by = this.current_user_id;
				// $("#addShipperSurveyModal").modal("hide");
				bootstrap.Modal.getInstance(document.getElementById('addShipperSurveyModal')).hide();
				this.showLoading("Saving ...");
				axios
					.post(this.docRoot+"/shippersurvey/save", {shippersurvey: this.shippersurveyForAdd})
					.then(async function (response) {
						thisVar.closeSwal();
						var status = response.data.status;
						if (status == 1) {
							// Ajax to submit
							thisVar.showToast("Shipper Survey saved successfully", "success", "bottom", 3000);
							if(thisVar.mode === "mobileapp") {
								window.location = thisVar.docRoot + "/operation-successful";
							}
							setTimeout(() => {
								thisVar.dataprops.reload = true;
							}, 1500);
							thisVar.shippersurveyForAdd = initialState();
							thisVar.tankNoVerified = false;
							thisVar.v$.$reset();
						} else thisVar.showErrors("Shipper Survey could not be saved successfully", response.data.messages, "bottom", 3000);
					})
					.catch(function (error) {
						console.log(error);
						thisVar.closeSwal();
						thisVar.showToast("Shipper Survey could not be saved successfully", "error", "bottom", 3000);
					});
			},
			prepareEditShipperSurvey(shippersurvey) {
				this.shippersurveyForAdd = Object.assign({}, shippersurvey);
				this.tankNoVerified = false;
				this.addEditModal.show();
				if (this.shippersurveyForAdd.surveyor_id) {
					if (Array.isArray(this.allSurveyorIdList) && this.allSurveyorIdList.length > 0) {
						let _allRelationList = this.allSurveyorIdList;
						let relationId = parseInt(this.shippersurveyForAdd.surveyor_id);
						this.shippersurveyForAdd.surveyor_id = _allRelationList.find(item => item.id === relationId);
					}
				}
				if (this.shippersurveyForAdd.customer_id) {
					if (Array.isArray(this.allCustomerIdList) && this.allCustomerIdList.length > 0) {
						let _allRelationList = this.allCustomerIdList;
						let relationId = parseInt(this.shippersurveyForAdd.customer_id);
						this.shippersurveyForAdd.customer_id = _allRelationList.find(item => item.id === relationId);
					}
				}
				if (this.shippersurveyForAdd.for_shipper_id) {
					if (Array.isArray(this.allCustomerIdList) && this.allCustomerIdList.length > 0) {
						let _allRelationList = this.allCustomerIdList;
						let relationId = parseInt(this.shippersurveyForAdd.for_shipper_id);
						this.shippersurveyForAdd.for_shipper_id = _allRelationList.find(item => item.id === relationId);
					}
				}
				if (this.shippersurveyForAdd.inspection_location_id) {
					if (Array.isArray(this.allInspectionLocationIdList) && this.allInspectionLocationIdList.length > 0) {
						let _allRelationList = this.allInspectionLocationIdList;
						let relationId = parseInt(this.shippersurveyForAdd.inspection_location_id);
						this.shippersurveyForAdd.inspection_location_id = _allRelationList.find(item => item.id === relationId);
					}
				}
			},
			viewShipperSurvey(shippersurvey) {
				this.readShipperSurvey = shippersurvey;
				this.readModal.show();
			},
			toggleShipperSurvey(shippersurvey, status) {
				var thisVar = this;
				Swal.fire({
					icon: "question",
					html: "Do you really want to " + (status == 1 ? "reactivate" : "deactivate") + ' the Shipper Survey - <br/>"' + shippersurvey.tank_container_no + '"?',
					showCancelButton: true
				}).then((result) => {
					if (result.isConfirmed) {
						thisVar.shippersurveyForAdd = shippersurvey;
						thisVar.shippersurveyForAdd.status = status;
						thisVar.shippersurveyForAdd.action = "status";
						thisVar.saveShipperSurvey();
					}
				});
			},
			verifyTankNumber() {
				var that = this;
				this.showLoading("Verifying ...");
				axios.post(this.docRoot + "/shippersurvey/verify-tank-number", {tankNo: this.shippersurveyForAdd.tank_container_no}).then(async function (response) {
					that.closeSwal();
					console.log(response);
					var status = response.data.status;
					if (status == 1){
						that.tankNoVerified = true;
						if (response.data.hasOwnProperty("lastthree") && response.data.lastthree.length > 0) {
							let arrLastThree = response.data.lastthree;
							that.lastThree = arrLastThree.filter((item, index) => arrLastThree.indexOf(item) === index);
						}
					}
					else {
						that.tankNoVerified = false;
						that.showErrors(response.data.message, "error", "bottom", 3000);
					}
				});
			},
			printShippersurvey(shippersurvey) {
				window.location = this.docRoot+'/shippersurvey/export-to-pdf/' + shippersurvey.id;
				this.showToast("Printing. Please wait ...", "success", "bottom", 3000);
			},
			async uploadImages(shippersurvey) {
				this.showLoading("Loading images ...");
				await this.refreshObject(shippersurvey, "ShipperSurvey", 1);
				this.closeSwal();
			},
			displayLabelSetting ({id, text}) {
				return `${text}`;
			},
		},
		async mounted() {
			this.addEditModal = new bootstrap.Modal(this.$refs.addEditModal, {backdrop: "static", keyboard: false});
			this.readModal = new bootstrap.Modal(this.$refs.readModal, {backdrop: "static", keyboard: false});
			if (this.mode && this.mode == "mobileapp") {
				if(this.param1 && this.param1 != null && this.param1 != undefined) {
					if (this.id !== undefined && !isNaN(this.id)) {
						var URL = this.docRoot + "/api/shippersurvey/get-record/" + this.id;
						var that = this;
						this.showLoading("Loading ...");
						axios.post(URL, {}).then(function (response) {
							let shippersurveyObj = Object.assign({}, response.data);
							if(that.param1 === "edit"){
								that.prepareEditShipperSurvey(shippersurveyObj);
							}else{
								that.viewShipperSurvey(shippersurveyObj);
							}
							that.closeSwal();	
						})
						.catch(function (error) {
							console.log(error);
						});
					}
				}else{
					this.addEditModal.show();
				}
				this.$refs.addEditModal.addEventListener('hidden.bs.modal', () => { window.location = this.docRoot + "/operation-canceled"; });
				this.$refs.readModal.addEventListener('hidden.bs.modal', () => { window.location = this.docRoot + "/operation-canceled"; });
			}
			this.allCompanyIdList = await this.loadAllCompany(true);

			let _allSurveyorIdList = await this.loadAllSurveyor(true);
			if(Array.isArray(_allSurveyorIdList) && _allSurveyorIdList.length > 0){
				this.allSurveyorIdList = _allSurveyorIdList.map(x => {return { id: x.id, text: x.name }});
			}
			let _allCustomerIdList = await this.loadAllCustomer(true);
			if(Array.isArray(_allCustomerIdList) && _allCustomerIdList.length > 0){
				this.allCustomerIdList = _allCustomerIdList.map(x => {return { id: x.id, text: x.name }});
			}
			let _allForShipperIdList = await this.loadAllCustomer(true);
			if(Array.isArray(_allForShipperIdList) && _allForShipperIdList.length > 0){
				this.allForShipperIdList = _allForShipperIdList.map(x => {return { id: x.id, text: x.name }});
			}
			let _allInspectionLocationIdList = await this.loadAllInspectionLocation(true);
			if(Array.isArray(_allInspectionLocationIdList) && _allInspectionLocationIdList.length > 0){
				this.allInspectionLocationIdList = _allInspectionLocationIdList.map(x => {return { id: x.id, text: x.name }});
			}
			this.arrYesNoNA = [
				{id: "1", title: "Yes"},
				{id: "0", title: "No"},
				{id: "-1", title: "NA"}
			];
			this.allGasketTypeList = [
				{id: "1", title: "Super Tyt"},
				{id: "2", title: "Taflon"},
				{id: "3", title: "Rubber"},
				{id: "4", title: "Nylon"}
			];
		}
	};
</script>
